import { render, staticRenderFns } from "./MessageListMessageCompact.vue?vue&type=template&id=44d09d1c&scoped=true&functional=true&"
import script from "./MessageListMessageCompact.vue?vue&type=script&lang=js&"
export * from "./MessageListMessageCompact.vue?vue&type=script&lang=js&"
import style0 from "./MessageListMessageCompact.vue?vue&type=style&index=0&id=44d09d1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "44d09d1c",
  null
  
)

export default component.exports